import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export type FunMode = 'clouds' | 'ocean' | 'mountains' | 'forest' | 'city';

export const funModeAtom = atomWithStorage<{
  enabled: boolean;
  background: FunMode;
}>('funMode', {
  enabled: false,
  background: 'clouds',
});

export const useFunMode = () => {
  const [funMode, setFunMode] = useAtom(funModeAtom);

  return { funMode, setFunMode };
};
